import { debounce, isNumber } from '@qcwp/utils'
import type inputVue from '../input.vue'
import type listVue from '../list.vue'
import { Comment, useComment, useCommentListPages } from '~~/src/server/modules/article/hook'
import type { AddArticleCommentParams, AddArticleCommentResponse } from '~~/src/server/modules/article/type'
import { useAuth } from '~~/src/store'

export type InputPropsType = InstanceType<typeof inputVue>['$props']
export type InputEmitsType = InstanceType<typeof inputVue>['$emit']
export function useCommentInputComponent(props: InputPropsType, emits: InputEmitsType) {
  const $bus = useNuxtApp().$bus as any
  const inputRef = ref()
  // 是否发送评论请求
  const isLoading = ref(false)
  // 评论内容
  const commentContent = ref('')
  // 评论请求
  const debounceCommentHandle = debounce(commentHandle, 300, { maxWait: 1000 })
  const { sendComment } = useComment()
  async function commentHandle(articleId: string, commentId?: string) {
    if (!unref(commentContent))
      return vantToast('请输入评论内容')
    if (!articleId)
      return vantToast('文章id获取失败，请刷新后重试')
    const params: AddArticleCommentParams = { content: unref(commentContent), articleId }
    if (commentId)
      params.toCommentId = commentId
    emits('commentBefore', unref(commentContent))

    isLoading.value = true
    const res = await sendComment(params)
    if (res)
      clearInput()

    setTimeout(() => {
      isLoading.value = false
      if (res) {
        emits('commentAfter', res)
        // console.log('props', props)
        $bus.emit('COMMENT_ADD', { result: res, props: { ...props } })
      }
    }, 10)
  }
  function focusHandle() {
  }
  function blurHandle() {
    changeStatueHandle()
  }
  function changeHandle() {
    // console.log('change')
  }
  // 如果没有输入内容，则把输入框隐藏
  function changeStatueHandle() {
    if (commentContent.value.length)
      return
    if (props.show !== null)
      emits('update:show', false)
  }
  function clearInput() {
    commentContent.value = ''
    emits('update:show', false)
  }
  onMounted(() => {
    nextTick(() => {
      if (props.autoFocus)
        inputRef.value?.focus()
    })
  })

  return {
    inputRef,
    isLoading,
    commentContent,
    debounceCommentHandle,
    commentHandle,

    focusHandle,
    blurHandle,
    changeHandle,
    changeStatueHandle,
  }
}

export type CommentListPropsType = InstanceType<typeof listVue>['$props']
export type CommentListEmitsType = InstanceType<typeof listVue>['$emit']
export function useCommentListComponent(props: CommentListPropsType, _emits?: CommentListEmitsType) {
  const { USER_INFO, USER_HEAD, USER_NAME } = storeToRefs(useAuth())
  const { list, mediaNameMap, state, pagination, getData, initHandle } = useCommentListPages(props.param)

  // event bus
  const $bus = useNuxtApp().$bus as any
  onMounted(() => {
    // 需要放入钩子中，否则list会是undefined
    $bus.off('COMMENT_ADD')
    $bus.on('COMMENT_ADD', (data: { result: AddArticleCommentResponse; props: InputPropsType }) => {
      const user = {
        mediaAvatar: USER_HEAD.value,
        mediaName: USER_NAME.value,
        mediaUserId: USER_INFO.value.type !== 'GhostUserInfo' ? USER_INFO.value.id : '',
      }
      const { result, props: inputProps } = data
      // console.log(data, result, inputProps)
      $bus.emit('COMMENT_COUNT_CHANGE', (props.commentCount || 0) + 1)
      const isReply = isNumber(inputProps.option?.index)
      if (isReply) {
        const option = inputProps.option
        const index = option?.index || 0
        const item = list[index]
        // console.log(item, list, index)
        if (item && !item.reply)
          item.reply = item.replyInit()

        // 修改二级评论数
        item.replyCount = `${Number(item.replyCount) + 1}`
        if (item.showReply || item.reply?.list?.length) {
          item.reply?.list.unshift(new Comment({
            ...result,
            remark: '',
            toCommentId: '',
            replyCount: '0',
            mediaAvatar: result.mediaAvatar || user.mediaAvatar,
            mediaName: result.mediaName || user.mediaName,
            mediaUserId: result.mediaUserId || user.mediaUserId,
            toMediaAvatar: result.toMediaAvatar || option?.toMediaAvatar || '',
            toMediaName: result.toMediaName || option?.toMediaName || '',
            toMediaUserId: result.toMediaUserId || option?.toMediaUserId || '',
          }))
        }
        if (!item.showReply)
          item.changeShowReply()
      }
      else {
        list.unshift(new Comment({
          ...result,
          remark: '',
          toCommentId: '',
          replyCount: '0',
          mediaAvatar: result.mediaAvatar || user.mediaAvatar,
          mediaName: result.mediaName || user.mediaName,
          mediaUserId: result.mediaUserId || user.mediaUserId,
        }))
      }
    })
  })
  onUnmounted(() => {
    $bus.off('COMMENT_ADD')
  })

  return {
    list,
    mediaNameMap,
    state,
    pagination,
    getData,
    initHandle,
  }
}
